import './navigation';
import './header';
import './ajax-add-to-cart';
import './related';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

if (window.innerWidth > 1023) {
    gsap.fromTo(
        '.BannerScrollImage',
        {
            y: -600,
            scale: 0.4,
        },
        {
            y: 0,
            scale: 1,
            scrollTrigger: {
                trigger: '.BannerScrollImage',
                start: 'top center',
                end: 'bottom top',
                scrub: true,
            },
        },
    );
}

if (window.innerWidth > 1023) {
    const pinWrappers = document.querySelectorAll('.pin-wrapper');

    pinWrappers.forEach((pinWrapper) => {
        const section1 = pinWrapper.querySelector('.section-1');
        const section2 = pinWrapper.querySelector('.section-2');

        if (!section1 || !section2) {
            console.warn('Jeden z wymaganych elementów nie istnieje w pin-wrapperze. Pomijam.');
            return;
        }

        const section2Height = section2.offsetHeight;
        const initialPinWrapperHeight = pinWrapper.offsetHeight;

        const isWhiteWrapper = pinWrapper.classList.contains('pin-wrapper-white');

        if (isWhiteWrapper) {
            gsap.set(section1, { opacity: 1 });
        } else {
            gsap.set(section1, { filter: 'brightness(1)' });
        }

        gsap.to(section1, {
            ...(isWhiteWrapper ? { opacity: 0.5 } : { filter: 'brightness(0.5)' }),
            y: -100,
            scrollTrigger: {
                trigger: section2,
                start: 'top bottom',
                end: 'top center',
                scrub: 1,
            },
        });

        gsap.to(section2, {
            y: -section2Height,
            scrollTrigger: {
                trigger: section2,
                start: 'top bottom',
                end: `+=${section2Height}`,
                scrub: 1,
                pin: pinWrapper,
                pinSpacing: false,
                onUpdate: (self) => {
                    const progress = self.progress;
                    pinWrapper.style.height = `${
                        initialPinWrapperHeight - section2Height * progress
                    }px`;
                },
                onLeave: () => {
                    pinWrapper.style.height = '0';
                },
                onEnterBack: () => {
                    pinWrapper.style.height = `${initialPinWrapperHeight}px`;
                },
            },
        });
    });
}

const rows = document.querySelectorAll('.ScrollRow');

if (rows.length && window.innerWidth >= 1024) {
    // Ustawiamy startową pozycję
    gsap.set(rows, { y: 0 });

    // Wspólna animacja z opóźnieniem między elementami
    gsap.to(rows, {
        y: -200,
        stagger: 0.25,
        scrollTrigger: {
            trigger: rows[0], // używamy pierwszego elementu jako trigger
            start: 'top bottom',
            end: 'top center',
            scrub: 1,
        },
    });
}

if (window.innerWidth > 1023) {
    gsap.utils.toArray('.ConfigScrollImageLeft').forEach((el) => {
      gsap.fromTo(
        el,
        { y: -300 },
        {
          y: 0,
          scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'top center',
            scrub: true,
          },
        }
      );
    });
  
    gsap.utils.toArray('.ConfigScrollImageRight').forEach((el) => {
      gsap.fromTo(
        el,
        { y: 300 },
        {
          y: 0,
          scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'top center',
            scrub: true,
          },
        }
      );
    });
  }
  